import TypeaheadInput from "@/components/TypeaheadInput";
import ThingToDoItem from "@/components/ThingToDoItem";
import {useState} from "react";
import {capitalize, transformObj} from "@/lib/util";

export default function ThingsToDo({thingsToDo, park}) {
    //console.log(park.activities)

    // create activities object for typeahead input
    const replacer = { "id": "value", "name" :"label"};
    let activitiesFromThingsToDo = thingsToDo.reduce((acc, curr) => {
        return [...acc, ...curr.activities]
        // return accumulator.includes(currentValue) ? accumulator : [...accumulator, currentValue.activities];
    }, []);
    let activitiesForTypeahead = activitiesFromThingsToDo.map(o => transformObj(o, replacer))
    //console.log(activitiesForTypeahead)

    const [selectedActivity, setSelectedActivity] = useState(null);
    const [selectedActivityArticles, setSelectedActivityArticles] = useState([]);
    const handleActivityChange = (selectedOption) => {
        setSelectedActivity(selectedOption);
        if (selectedOption) {
            let selectedActivity = thingsToDo.filter(thing => JSON.stringify(thing.activities).includes(`"name":"${selectedOption.label}"`))
            setSelectedActivityArticles(selectedActivity)
        }
    };

    return(
        <>
            {/*<TypeaheadInput options={activitiesForTypeahead} onChange={handleActivityChange} autoFocus={true} isClearable placeholder="Filter by activity"/>*/}
            {selectedActivity && selectedActivityArticles ?
                selectedActivityArticles.map((thing) => <ThingToDoItem key={thing.id} thing={thing} parkName={park.fullName} /> )
                :
            thingsToDo.slice(0,10).map((thing) => <ThingToDoItem key={thing.id} thing={thing} parkName={park.fullName}/> )}
        </>
    )
}